import { z } from 'zod';

/* Login --------------------------------------------------------- */

export const loginSchema = z.object({
  username: z.string().min(1, 'Username is required').max(120, 'Too long'),
  password: z.string().min(1, 'Password is required').max(200, 'Too long'),
});
export type LoginInput = z.infer<typeof loginSchema>;

/* Reset password flow (3 steps) --------------------------------- */

export const resetStartSchema = z.object({
  username: z.string().min(1, 'Username is required').max(120, 'Too long'),
});
export type ResetStartInput = z.infer<typeof resetStartSchema>;

export const resetOtpSchema = z.object({
  otp: z.string().min(4, 'OTP is too short').max(10, 'OTP is too long'),
});
export type ResetOtpInput = z.infer<typeof resetOtpSchema>;

/** Shared password rules — keep in sync with backend policy. */
const passwordRules = z
  .string()
  .min(8, 'Use at least 8 characters')
  .max(128, 'Too long')
  .regex(/[A-Za-z]/, 'Include at least one letter')
  .regex(/[0-9]/, 'Include at least one number');

export const newPasswordSchema = z
  .object({
    password: passwordRules,
    confirmPassword: z.string().min(1, 'Confirm your password'),
  })
  .refine((d) => d.password === d.confirmPassword, {
    message: "Passwords don't match",
    path: ['confirmPassword'],
  });
export type NewPasswordInput = z.infer<typeof newPasswordSchema>;
